/**
 * Get PRISM image url
 *
 * @param {String} src
 * @param {Number} width
 * @param {Number} height
 * @param {Object} params
 *
 * @link https://docs.google.com/document/d/1UHQ6NoB3CTx3dikK_dXoyEZxQP6Cp_REOxd7U7Biccg/edit?ts=5b990694
 *
 * @see functions.php
 */
export const getPrismImageUrl = (src, width = '$original$', fallback = null) => {
    if (src && (isNaN(Number(width)) || Number(width) >= 0)) {
        return String(src).replace('$original$', String(width));
    } else {
        return String(fallback);
    }
};
